import { render, staticRenderFns } from "./HospitalityStrategies.vue?vue&type=template&id=653fa146&scoped=true&"
import script from "./HospitalityStrategies.vue?vue&type=script&lang=ts&"
export * from "./HospitalityStrategies.vue?vue&type=script&lang=ts&"
import style0 from "./HospitalityStrategies.vue?vue&type=style&index=0&id=653fa146&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fa146",
  null
  
)

export default component.exports